import React, { useState, useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { Loader } from 'shared/components/Loader'
import { checkFileType } from 'components/ImportCustomerModal/utils/checkfilscsv'
import PropTypes from 'prop-types'

export const UploadFileDropZone = ({
  file,
  fileName,
  setFile,
  loading,
  onUpload,
  setHasError,
  fileSizeLimit = 10 * 1024 * 1024,
  instructionHeaderText = 'Drag and drop your CSV file here',
  description = <React.Fragment />,
}) => {
  const [warningMessage, setWarningMessage] = useState('')

  const removeFile = useCallback(() => {
    setFile({ name: '', data: null, rawFile: null })
  }, [setFile])

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0]

      //default 10 MB limit
      if (file.size > fileSizeLimit) {
        const fileSizeLimitMB = fileSizeLimit / (1024 * 1024)
        setWarningMessage(
          `File size exceeds the ${fileSizeLimitMB}MB limit. Please upload a smaller file.`
        )
        setHasError(true)
      } else {
        checkFileType(file).then((result) => {
          if (result.file) {
            onUpload(result.file)
            setWarningMessage('')
            setHasError(false)
          } else {
            setWarningMessage(result.warningMessage)
            setHasError(true)
          }
        })
      }
    },
    [onUpload, fileSizeLimit, setHasError]
  )

  const { getRootProps, getInputProps } = useDropzone({ onDrop })

  if (loading) {
    return (
      <div className="dropzone-container" {...getRootProps()}>
        <Loader withContainer containerHeight="auto" />
      </div>
    )
  }

  return (
    <React.Fragment>
      <div className="dropzone-container" {...getRootProps()}>
        {file ? (
          <div className="flex flex-col items-center justify-between">
            <p className="mb0">
              <i className="fal fa-file-csv" /> {fileName}
            </p>
            <a className="cursor-pointer !underline" onClick={removeFile}>
              Remove
            </a>
          </div>
        ) : (
          <div>
            <h3>{instructionHeaderText}</h3>
            <a className="cursor-pointer !underline">or select a file from your computer...</a>
            {warningMessage && (
              <div>
                <p className="dropzone-warning">{warningMessage}</p>
              </div>
            )}
            {description}
            <input type="file" {...getInputProps()} accept=".csv" />
          </div>
        )}
      </div>
    </React.Fragment>
  )
}

UploadFileDropZone.propTypes = {
  file: PropTypes.object,
  fileName: PropTypes.string,
  setFile: PropTypes.func,
  loading: PropTypes.bool,
  onUpload: PropTypes.func,
  setHasError: PropTypes.func,
  fileSizeLimit: PropTypes.number,
  instructionHeaderText: PropTypes.string,
  description: PropTypes.node,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/UploadFileDropzone/index.js